import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, RouterLink } from "@angular/router";
import { MutexService } from "common/concurrency/mutex.service";
import { ErrorReportService } from "common/exception/error-report.service";
import { MainService } from "core/main.service";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FocusErrorDirective } from "common/form/focus-error.directive";
import { TrimDirective } from "common/trim.directive";
import { AutofocusDirective } from "common/autofocus/autofocus.directive";
import { AutoGrowDirective } from "common/autoGrow/autogrow.directive";

@Component({
	selector: "stages-error-report",
	templateUrl: "error-report.component.html",
	imports: [
		RouterLink,
		TranslateModule,
		ReactiveFormsModule,
		FormsModule,
		FocusErrorDirective,
		TrimDirective,
		AutofocusDirective,
		AutoGrowDirective,
		AsyncPipe,
	],
})
export class ErrorReportComponent implements OnInit, OnDestroy {
	private route = inject(ActivatedRoute);
	private readonly mutexService = inject(MutexService);
	private readonly mainService = inject(MainService);
	private readonly errorReportService = inject(ErrorReportService);

	private destroy$ = new Subject<boolean>();
	inProgress = false;
	subject!: string;
	messageBody!: string;
	paramMap$!: Observable<ParamMap>;

	ngOnInit(): void {
		this.paramMap$ = this.route.paramMap;
		this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((paramMap) => {
			const incidentId = paramMap.get("incidentId");
			this.subject = incidentId ? `[Incident ID ${incidentId}]` : "";
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}

	async send(): Promise<void> {
		this.inProgress = true;
		try {
			await this.mutexService.invokeWithResult("sendErrorReport", async () =>
				this.errorReportService.send(this.subject, this.messageBody),
			);
		} finally {
			this.inProgress = false;
		}
		void this.mainService.goHome(
			this.route.snapshot.paramMap.has("processVersion") ? this.route.snapshot.paramMap.get("processVersion")! : "_vv",
		);
	}

	cancel(): void {
		void this.mainService.goHome(
			this.route.snapshot.paramMap.has("processVersion") ? this.route.snapshot.paramMap.get("processVersion")! : "_vv",
		);
	}
}
